import React from 'react';
import type { TpApproach } from '../../patient-treatment/types';
import { Icon } from '../Icon/Icon';

export interface PatientTreatmentApproachProps {
  approach: TpApproach;
}

export function PatientTreatmentApproach({ approach: a }: PatientTreatmentApproachProps) {
  return (
    <section
      className="tc-card tc-rise tc-d1 mb-[26px] border-l-[3px] border-l-[var(--ai-3)] px-[26px] py-[22px]"
      style={{
        background:
          'linear-gradient(180deg, var(--cream-1) 0%, color-mix(in srgb, var(--ai-3) 4%, var(--cream-1)) 100%)',
      }}
    >
      <div className="mb-[11px] flex items-center gap-2">
        <Icon kind="bolt" size={14} stroke={1.9} style={{ color: 'var(--ai-3)' }} />
        <span className="tc-eyebrow text-[var(--ai-3)]">The approach for this conversation</span>
      </div>
      <h3 className="mb-3.5 font-[var(--font-display)] text-[27px] font-semibold leading-[1.18] tracking-[-0.03em] text-[var(--ink-0)]">
        {a.lead}
        <span className="font-medium text-[var(--ink-2)]">{a.tail}</span>
      </h3>
      <p className="mb-4 max-w-[720px] text-[14.5px] leading-[1.65] tracking-[-0.005em] text-[var(--ink-1)]">
        {a.body}
      </p>
      {a.dont !== undefined && a.dont !== '' ? (
        <div className="inline-flex items-center gap-2.5 rounded-[var(--r-md)] border border-[color-mix(in_srgb,var(--terracotta)_28%,transparent)] bg-[var(--terracotta-tint)] px-3.5 py-2.5">
          <Icon kind="x" size={13} stroke={2.2} style={{ color: 'var(--terracotta)' }} />
          <span className="text-[12.5px] font-medium tracking-[-0.005em] text-[var(--ink-1)]">
            <b className="font-semibold text-[var(--terracotta)]">Don’t:</b> {a.dont}
          </span>
        </div>
      ) : a.historicalPattern !== '' ? (
        <div className="inline-flex items-center gap-2.5 rounded-[var(--r-md)] border border-[var(--cream-2)] bg-[var(--surface-mute)] px-3.5 py-2.5">
          <Icon kind="stopwatch" size={13} style={{ color: 'var(--ink-3)' }} />
          <span className="text-[12.5px] font-medium tracking-[-0.005em] text-[var(--ink-2)]">
            {a.historicalPattern}
          </span>
        </div>
      ) : null}
    </section>
  );
}
